/* Hallmark · component: Container · genre: modern-minimal · theme: maeiz-tokens */
import React from "react";
import { clsx } from "clsx";

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
    maxWidth?: "sm" | "md" | "lg" | "xl" | "2xl" | "full";
    padding?: "none" | "sm" | "md" | "lg";
    /** Surface wrapper for page regions */
    surface?: boolean;
}

export const Container: React.FC<ContainerProps> = ({
    children,
    maxWidth = "xl",
    padding = "md",
    surface = false,
    className,
    ...props
}) => {
    const maxWidthStyles = {
        sm: "max-w-screen-sm",
        md: "max-w-screen-md",
        lg: "max-w-screen-lg",
        xl: "max-w-screen-xl",
        "2xl": "max-w-screen-2xl",
        full: "max-w-full",
    };

    const paddingStyles = {
        none: "",
        sm: "px-3",
        md: "px-4 sm:px-6",
        lg: "px-6 sm:px-8",
    };

    return (
        <div
            className={clsx(
                "mx-auto w-full",
                maxWidthStyles[maxWidth],
                paddingStyles[padding],
                surface && "rounded-2xl border border-neutral-border/80 bg-white p-4 shadow-mz-sm dark:border-white/10 dark:bg-neutral-navy sm:p-6",
                className,
            )}
            {...props}
        >
            {children}
        </div>
    );
};
